import { paths, publicPaths } from "utils/constants";
import SmartRender from "containers/SmartRender";
import PreCheckout from "containers/Plan/PreCheckout";
import PortInNumber from "containers/Plan/PortInNumber";
import NewNumber from "containers/Plan/NewNumber";
import PersonalDetails from "containers/Plan/PersonalDetails";
import ConnectionDetails from "containers/Plan/ConnectionDetails";
import DeliveryInfo from "containers/Plan/DeliveryInfo";
import OrderSummary from "containers/Plan/OrderSummary";
import Payment from "containers/Payment";
import PaymentStatus from "containers/PaymentStatus";
import PaymentReturn from "containers/PaymentReturn";
import PaymentQR from "containers/PaymentQR";
import ManageOrder from "containers/ManageOrder";
import Chat from "containers/Chat";
import ChangeNumber from "containers/OrderActions/ChangeNumberAction";
import SuspendNumber from "containers/OrderActions/SuspendNumberAction";
import ReportLostSim from "containers/OrderActions/ReportLostSimAction";
import ReportFraud from "containers/OrderActions/ReportFraudAction";
import ReplaceWithEsim from "containers/OrderActions/ReplaceWithEsimAction";
import ResendEsimQR from "containers/OrderActions/ResendEsimQRAction";
import ShopOrderSummary from "containers/Plan/ShopOrderSummary";
import ScheduleDelivery from "containers/Plan/ScheduleDelivery";
import TerminateNumber from "containers/OrderActions/TerminateNumberAction";
import SelfActivationDelivery from "containers/SelfActivationDelivery";
import SelfActivationDeliverySuccess from "containers/SelfActivationDelivery/SelfActivationDeliverySuccess";
import IdentityVerification from "containers/IdentityVerification";
import SimVerification from "containers/SimActivation/SimVerification";
import VerifyIdentity from "containers/SimActivation/VerifyIdentity";
import ManagePortIn from "containers/ManagePortIn";
import RequestPortOut from "containers/RequestPortOut";
import ReversePortIn from "containers/ReversePortIn";
import SimActivationSuccess from "containers/SimActivation/SimActivationSuccess";
import OutstandingBills from "containers/OrderActions/OutstandingBillsAction";
import IncomingInternationalCallsSMS from "containers/OrderActions/IncomingInternationalCallsSMS";
import DirectLinkExpired from "containers/OrderActions/DirectPaymentLinkExpiredPage";
import OutstandingBillsPaymentStatus from "containers/OutstandingBillsPaymentStatus";
import UploadIdentity from "containers/UploadIdentity";
import Ping from "components/Ping";
import ZendeskWidget from "components/ZendeskWidget";
import DeepLink from "containers/DeepLink";
import SimActivationOrderSummary from "containers/SimActivation/OrderSummary";
import SimActivationPaymentReturn from "containers/SimActivation/PaymentReturn";
import ESimActivation from "containers/SimActivation/ESimActivation";
import SimActivationStatus from "containers/SimActivation/SimActivationStatus";
import SimActivationStatusPolling from "containers/SimActivation/SimActivationStatus/SimActivationStatusPolling";
import SimActivationStatusSuccess from "containers/SimActivation/SimActivationStatus/SimActivationStatusSuccess";
import Survey from "containers/Survey";
import ShopPayment from "containers/Shop/Payment";
import Login from "containers/Login";
import OTPSubmitPage from "containers/VerifyOTP/OTPSubmitPage";
import PlanSelection from "containers/PlanSelection";
import OrderCancellation from "containers/OrderCancellation";
import ChannelOTP from "containers/Plan/ChannelOTP";
import UserDetailsConfirmation from "containers/UserDetailsConfirmation";
import SocialAuthRedirection from "containers/SocialAuthRedirection";
import Profile from "containers/Profile";
import Ekyc from "containers/Ekyc";
import SelfActivationPlan from "containers/SelfActivationDelivery/Plan";
import SelfActivationOrderSummary from "containers/SelfActivationDelivery/OrderSummary";
import WireCardOneTimePayment from "containers/WireCardOneTimePayment";
import CisRequest from "containers/CisRequest";
import CisRequestHr from "containers/CisRequestHR";
import CisRequestPartners from "containers/CisRequestPartners";
import Phones from "containers/Phones";
import AmazonPayment from "containers/Payment/amozon";
import AuLostServiceRedirection from "containers/SocialAuthRedirection/AuLostServiceRedirection";
import MockedAuConsentScreen from "containers/SocialAuthRedirection/AuLostServiceRedirection/MockedAuConsentScreen";
import SuspendNumberSummary from "containers/OrderActions/SuspendNumberAction/SuspensionSummary";
import ConfirmNumberChange from "containers/OrderActions/ChangeNumberAction/ConfirmNumberChange";
import SubmittedNumberChange from "containers/OrderActions/ChangeNumberAction/SubmittedNumberChange";
import OrderActionGenericStatus from "containers/OrderActions/OrderActionGenericStatus";
import Authorization from "containers/Authorization";
import SwitchToEsimAction from "containers/OrderActions/SwitchToEsimAction";
import EmailSelection from "containers/SocialEmailselection/EmailSelection";
import OutstandingBillPayment from "containers/OutstandingBillPayment";
import UpgradeTo5G from "containers/OrderActions/UpgradeTo5GAction/UpgradeTo5G";

export const routes = [
  {
    path: paths.SIM_ACTIVATION_ORDER_SUMMARY,
    Component: SimActivationOrderSummary
  },
  {
    path: paths.SELF_ACTIVATION_ORDER_SUMMARY,
    Component: SelfActivationOrderSummary
  },
  {
    path: paths.SELF_ACTIVATION_PLAN,
    Component: SelfActivationPlan
  },
  {
    path: paths.SIM_ACTIVATION_PAYMENT_RETURN,
    Component: SimActivationPaymentReturn
  },
  {
    path: paths.LANDING_PAGE,
    Component: SmartRender
  },
  {
    path: paths.SELF_ACTIVATION_DELIVERY_SUCCESS,
    Component: SelfActivationDeliverySuccess
  },
  {
    path: paths.SUCCESS,
    Component: SimActivationSuccess
  },
  {
    path: paths.SIM_VERIFICATION,
    Component: SimVerification
  },
  {
    path: paths.PSIM_VERIFICATION,
    Component: SimVerification
  },
  {
    path: paths.ESIM_VERIFICATION,
    Component: SimVerification
  },
  {
    path: paths.PLANS,
    Component: SelfActivationDelivery
  },
  {
    path: paths.SELF_ACTIVATION_DELIVERY,
    Component: SelfActivationDelivery
  },
  {
    path: paths.VERIFY_IDENTITY,
    Component: VerifyIdentity
  },
  {
    path: paths.ACTIVATE,
    Component: VerifyIdentity
  },
  {
    path: paths.ACTIVATE_SUCCESS,
    Component: SimActivationSuccess
  },
  {
    path: paths.MANAGE_ACTIVATE_SIM_CARD,
    Component: SimVerification
  },
  {
    path: paths.MANAGE_SIM_ACTIVATION_SUCCESS,
    Component: SimActivationSuccess
  },
  {
    path: paths.PRE_CHECKOUT,
    Component: PreCheckout
  },
  {
    path: paths.PORT_IN_NUMBER,
    Component: PortInNumber
  },
  {
    path: paths.NEW_NUMBER,
    Component: NewNumber
  },
  {
    path: paths.PERSONAL_DETAILS,
    Component: PersonalDetails
  },
  {
    path: paths.DELIVERY_INFO,
    Component: DeliveryInfo
  },
  {
    path: paths.PAYMENT_RETURN_V3,
    Component: PaymentReturn
  },
  {
    path: paths.PAYMENT_RETURN,
    Component: PaymentReturn
  },
  {
    path: paths.LEGACY_PAYMENT_RETURN,
    Component: PaymentReturn
  },
  {
    path: paths.PAYMENT_STATUS,
    Component: PaymentStatus
  },
  {
    path: paths.PAYMENT_PENDING,
    Component: PaymentStatus
  },
  {
    path: paths.PAYMENT_SUCCESS,
    Component: PaymentStatus
  },
  {
    path: paths.MANAGE_RESEND_ESIM_QR,
    Component: ResendEsimQR
  },
  {
    path: paths.PAYMENT_FAILED,
    Component: PaymentStatus
  },
  {
    path: paths.CHANGE_NUMBER,
    Component: ChangeNumber
  },
  {
    path: paths.CHANGE_NUMBER_CONFIRMATION,
    Component: ConfirmNumberChange
  },
  {
    path: paths.CHANGE_NUMBER_SUBMITTED,
    Component: SubmittedNumberChange
  },
  {
    path: paths.CHANGE_NUMBER_CANCEL,
    Component: SubmittedNumberChange
  },
  {
    path: paths.SUSPEND_NUMBER,
    Component: SuspendNumber
  },
  {
    path: paths.SUSPEND_NUMBER_SUMMARY,
    Component: SuspendNumberSummary
  },
  {
    path: paths.SUSPEND_NUMBER_FAIL,
    Component: SuspendNumberSummary
  },
  {
    path: paths.SUSPEND_NUMBER_INELIGIBLE,
    Component: SuspendNumberSummary
  },
  {
    path: paths.SUSPEND_NUMBER_CANCEL_CONFIRMATION,
    Component: SuspendNumberSummary
  },
  {
    path: paths.UPGRADE_TO_5G,
    Component: UpgradeTo5G
  },
  {
    path: paths.REPORT_LOST_SIM,
    Component: ReportLostSim
  },
  {
    path: paths.REPORT_FRAUD,
    Component: ReportFraud
  },
  {
    path: paths.CANCEL_TERMINATION,
    Component: TerminateNumber
  },
  {
    path: paths.CANCEL_PORT_IN,
    Component: ManagePortIn
  },
  {
    path: paths.CANCEL_PORT_IN_SUCCESS,
    Component: ManagePortIn
  },
  {
    path: paths.INITIATE_PORT_IN,
    Component: ManagePortIn
  },
  {
    path: paths.INITIATE_PORT_IN_SUCCESS,
    Component: ManagePortIn
  },
  {
    path: paths.REINITIATE_PORT_IN,
    Component: ManagePortIn
  },
  {
    path: paths.REINITIATE_PORT_IN_SUCCESS,
    Component: ManagePortIn
  },
  {
    path: paths.RESCHEDULE_PORT_IN,
    Component: ManagePortIn
  },
  {
    path: paths.RESCHEDULE_PORT_IN_SUCCESS,
    Component: ManagePortIn
  },
  {
    path: paths.OUTSTANDING_BILLS,
    Component: OutstandingBills
  },
  {
    path: paths.INCOMING_INTERNATIONAL_COMMS,
    Component: IncomingInternationalCallsSMS
  },
  {
    path: paths.OUTSTANDING_BILL_PAYMENT,
    Component: OutstandingBillPayment
  },
  {
    path: paths.DIRECT_LINK_EXPIRED,
    Component: DirectLinkExpired
  },
  {
    path: paths.OUTSTANDING_BILLS_PAYMENT_STATUS,
    Component: OutstandingBillsPaymentStatus
  },
  {
    path: paths.PAYMENT_CARD_UPDATE,
    Component: Payment
  },
  {
    path: paths.PAYMENT_QR,
    Component: PaymentQR
  },
  {
    path: paths.SHOP_ORDER_SUMMARY,
    Component: ShopOrderSummary
  },
  {
    path: paths.UPLOAD_IDENTITY,
    Component: UploadIdentity
  },
  {
    path: paths.PING,
    Component: Ping
  },
  {
    path: paths.SCANNER,
    Component: DeepLink
  },
  {
    path: paths.SELF_ACTIVATION_ICCID_SCANNER,
    Component: SimVerification
  },
  {
    path: paths.EKYC_VERIFY,
    Component: DeepLink
  },
  {
    path: paths.DASHBOARD,
    Component: DeepLink
  },
  {
    path: paths.WEBLOGIN,
    Component: DeepLink
  },
  {
    path: paths.CLOSEWEBVIEW,
    Component: DeepLink
  },
  {
    path: paths.LOGGED_OUT,
    Component: DeepLink
  },
  {
    path: paths.UPDATE_CARD_SUCCESS,
    Component: DeepLink
  },
  {
    path: paths.PROFILE_UPDATE_EMAIL_SUCESS,
    Component: DeepLink
  },
  {
    path: paths.APP_LINK_AU_ACCOUNT_SUCCESS,
    Component: DeepLink
  },
  {
    path: paths.ZENDESK,
    Component: ZendeskWidget
  },
  {
    path: paths.SURVEY,
    Component: Survey
  },
  {
    path: paths.SHOP_PAYMENT,
    Component: ShopPayment
  },
  {
    path: paths.IDENTITY_VERIFICATION,
    Component: IdentityVerification
  },
  {
    path: paths.USER_DETAILS_CONFIRMATION,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.PAYMENT,
    Component: Payment
  },
  {
    path: paths.PAYMENT_CARD,
    Component: Payment
  },
  {
    path: paths.EKYC,
    Component: Ekyc
  },
  {
    path: paths.SELF_ACTIVATION_SIM_DELIVERY,
    Component: SelfActivationDelivery
  },
  {
    path: paths.CIRCLES1_DEALS,
    Component: SelfActivationDelivery
  },
  {
    path: paths.PHONES,
    Component: Phones
  },
  {
    path: paths.PHONE_DETAILS,
    Component: Phones
  },
  {
    path: paths.PAYMENT_AMAZON,
    Component: AmazonPayment
  },
  {
    path: paths.VERIFY_IDENTITY_ORDER_SUMMARY,
    Component: SelfActivationOrderSummary
  },
  {
    path: paths.CIS_REQUEST,
    Component: CisRequest
  },
  {
    path: paths.CIS_REQUEST,
    Component: CisRequest
  },
  {
    path: paths.CIS_REQUEST_HR,
    Component: CisRequestHr
  },
  {
    path: paths.CIS_REQUEST_SUCCESS,
    Component: CisRequest
  },
  {
    path: paths.CIS_REQUEST_HR_SUCCESS,
    Component: CisRequestHr
  },
  {
    path: paths.CIS_PARTNERS,
    Component: CisRequestPartners
  },
  {
    path: paths.CIS_PARTNERS_SUCCESS,
    Component: SimActivationStatusSuccess
  },
  {
    path: paths.CHANNEL_OTP,
    Component: ChannelOTP
  }
];

export const authorizedRoutes = [
  {
    path: paths.ORDER_SUMMARY,
    Component: OrderSummary
  },
  {
    path: paths.CONNECTION_DETAILS,
    Component: ConnectionDetails
  },
  {
    path: paths.PROFILE,
    Component: Profile
  },
  {
    path: paths.PROFILE_EMAIL,
    Component: Profile
  },
  {
    path: paths.MANAGE_SIM_ACTIVATION,
    Component: SimVerification
  },
  {
    path: paths.MANAGE_ORDER,
    Component: ManageOrder
  },
  {
    path: paths.MANAGE_ORDER_AUTHORIZED,
    Component: Authorization
  },
  {
    path: paths.MANAGE_ESIM_QR,
    Component: ESimActivation
  },
  {
    path: paths.SIM_ACTIVATION_STATUS,
    Component: SimActivationStatus
  },
  {
    path: paths.SIM_ACTIVATION_PENDING,
    Component: SimActivationStatusPolling
  },
  {
    path: paths.SIM_ACTIVATION_SUCCESS,
    Component: SimActivationStatusSuccess
  },
  {
    path: paths.USER_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.AU_USER_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.OWNER_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.PORTIN_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.DELIVERY_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.CONTACT_DETAILS,
    Component: UserDetailsConfirmation
  },
  {
    path: paths.PAYMENT_CARD_UPDATE,
    Component: Payment
  },
  {
    path: paths.SIM_REPLACEMENT_CONNECTION_DETAILS,
    Component: ReportLostSim
  },
  {
    path: paths.SIM_REPLACEMENT_ESIM_ACTIVATION,
    Component: ESimActivation
  },
  {
    path: paths.SIM_REPLACEMENT_DELIVERY_DETAILS,
    Component: ReportLostSim
  },
  {
    path: paths.SIM_REPLACEMENT_CONTACT_DETAILS,
    Component: ReportLostSim
  },
  {
    path: paths.ORDER_CANCELLATION,
    Component: OrderCancellation
  },
  {
    path: paths.TERMINATE_NUMBER,
    Component: TerminateNumber
  },
  {
    path: paths.REPLACE_WITH_ESIM,
    Component: ReplaceWithEsim
  },
  {
    path: paths.WIRE_CARD_ONE_TIME_PAYMENT,
    Component: WireCardOneTimePayment
  },
  {
    path: paths.SWITCH_TO_ESIM,
    Component: SwitchToEsimAction
  },
  {
    path: paths.REVERSE_PORTIN,
    Component: ReversePortIn
  },
  {
    path: paths.REQUEST_PORT_OUT,
    Component: RequestPortOut
  },
  {
    path: paths.MANAGE_ACTION_GENERIC_STATUS,
    Component: OrderActionGenericStatus
  },
  {
    path: paths.SCHEDULE_DELIVERY,
    Component: ScheduleDelivery
  },
  {
    path: paths.CHAT,
    Component: Chat
  }
];

// These are the routes exposed openly by the app (For countries that has secured turned on)
export const publicRoutes = [
  {
    path: paths.PLAN_SELECTION,
    Component: PlanSelection
  },
  {
    path: publicPaths.SIGNUP_PAGE,
    Component: Login
  },
  {
    path: publicPaths.LOGIN_PAGE,
    Component: Login
  },
  {
    path: publicPaths.CONFIRM_EMAIL,
    // Same login container is used since from this path onwards it is same as a user login
    Component: Login
  },
  {
    path: publicPaths.SELECT_EMAIL,
    Component: EmailSelection
  },
  {
    path: publicPaths.AU_LOST_SERVICE_USER_CONFIRM,
    Component: EmailSelection
  },
  {
    path: publicPaths.VERIFY_OTP,
    Component: OTPSubmitPage
  },
  {
    path: publicPaths.LINE_AUTHENTICATION,
    Component: SocialAuthRedirection
  },
  {
    path: publicPaths.YAHOO_AUTHENTICATION,
    Component: SocialAuthRedirection
  },
  {
    path: publicPaths.GOOGLE_AUTHENTICATION,
    Component: SocialAuthRedirection
  },
  {
    path: publicPaths.FACEBOOK_AUTHENTICATION,
    Component: SocialAuthRedirection
  },
  {
    path: publicPaths.AU_AUTHENTICATION,
    Component: SocialAuthRedirection
  },
  {
    path: publicPaths.AU_LOST_SERVICE,
    Component: AuLostServiceRedirection
  },
  //TODO This is added only for testing purpose , need to remove this after au lost service page is developed
  {
    path: publicPaths.MOCK_AU_LOST_SERVICE,
    Component: MockedAuConsentScreen
  }
];
